<div class="headline-bar">
    <h1>Auftragshistorie</h1>
</div>
<div class="order-history-container">
    <div class="order-history-controls">
        <mat-form-field appearance="outline">
            <mat-label>Jahr</mat-label>
            <mat-select [(ngModel)]="selectedYear">
                <mat-option *ngFor="let year of years$ | async" [value]="year">{{ year }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <table class="global-table" mat-table [dataSource]="getFilteredOrders((orders$ | async) || [])" class="mat-elevation-z2 order-history-table">
        <!-- ID Column -->
        <ng-container matColumnDef="id">
            <th class="global-table-header-cell" mat-header-cell *matHeaderCellDef> ID </th>
            <td class="global-table-cell" mat-cell *matCellDef="let order"> {{ order.id }} </td>
        </ng-container>
        <!-- Date Column -->
        <ng-container matColumnDef="createdDate">
            <th class="global-table-header-cell" mat-header-cell *matHeaderCellDef> Datum </th>
            <td class="global-table-cell" mat-cell *matCellDef="let order"> {{ order.createdDate | date:'dd.MM.yyyy' }} </td>
        </ng-container>
        <!-- Status Column -->
        <ng-container matColumnDef="status">
            <th class="global-table-header-cell" mat-header-cell *matHeaderCellDef> Status </th>
            <td class="global-table-cell" mat-cell *matCellDef="let order"> {{ order.status?.name }} </td>
        </ng-container>
        <!-- Coins Used Column -->
        <ng-container matColumnDef="coinsUsed">
            <th class="global-table-header-cell" mat-header-cell *matHeaderCellDef> Coins </th>
            <td class="global-table-cell" mat-cell *matCellDef="let order"> {{ order.coinsUsed }} </td>
        </ng-container>
        <ng-container matColumnDef="actions">
            <th class="global-table-header-cell" mat-header-cell *matHeaderCellDef> Aktionen </th>
            <td class="global-table-cell" mat-cell *matCellDef="let order">
                <button mat-flat-button (click)="navigateToDetails(order)">Details</button>
            </td>
        </ng-container>
        <tr class="global-table-header-row" mat-header-row *matHeaderRowDef="['id', 'createdDate', 'status', 'coinsUsed', 'actions']"></tr>
        <tr class="global-table-row" mat-row *matRowDef="let row; columns: ['id', 'createdDate', 'status', 'coinsUsed', 'actions'];"></tr>
    </table>
    <div>
        <button mat-flat-button (click)="back()">Zurück</button>
    </div>
</div>